import { TranslatorTimesheetTag } from "../../languageTranslator/LanguageTranslatorTags";

const textColorCodes = ["#2cbbf1", "#ed2e2e", "#878787", "#23c944", "#bf9527"];
const colorCodes = ["#f3fbfe", "#feefef", "#f7f7f7", "#f2fcf4", "#fffaed"];
const shiftCodes = [
  "#FFEEDD ",
  "#FCFFD7 ",
  "#FFF1FD",
  "#E6FFBB",
  "#FDEAF2",
  "#F9E7FF",
  "#FFE6F7 ",
  "#E7E0FF",
  "#EAD3FF",
  "#DBE6FF",
  "#FFDFE0 ",
  "#CEDDFF ",
  "#FFE0C8",
  "#F4FFD4 ",
  "#FFE6D8 ",
  "#F6FFE5",
  "#D9FFDA",
  "#D1FFFD",
  "#EBFFF9",
];
<TranslatorTimesheetTag></TranslatorTimesheetTag>;
const shiftCodesWithNames = [
  { name: <TranslatorTimesheetTag>Light Peach</TranslatorTimesheetTag>, code: "#FFEEDD" },
  { name: <TranslatorTimesheetTag>Pear</TranslatorTimesheetTag>, code: "#FCFFD7" },
  { name: <TranslatorTimesheetTag>Lavender Blush</TranslatorTimesheetTag>, code: "#FFF1FD" },
  { name: <TranslatorTimesheetTag>Pear Green</TranslatorTimesheetTag>, code: "#E6FFBB" },
  { name: <TranslatorTimesheetTag>Thistle</TranslatorTimesheetTag>, code: "#FDEAF2" },
  { name: <TranslatorTimesheetTag>Mauve</TranslatorTimesheetTag>, code: "#F9E7FF" },
  { name: <TranslatorTimesheetTag>Classic Rose</TranslatorTimesheetTag>, code: "#FFE6F7" },
  { name: <TranslatorTimesheetTag>Periwinkle</TranslatorTimesheetTag>, code: "#E7E0FF" },
  { name: <TranslatorTimesheetTag>Mauve Orchid</TranslatorTimesheetTag>, code: "#EAD3FF" },
  { name: <TranslatorTimesheetTag>Pale Blue</TranslatorTimesheetTag>, code: "#DBE6FF" },
  { name: <TranslatorTimesheetTag>Misty Rose</TranslatorTimesheetTag>, code: "#FFDFE0" },
  { name: <TranslatorTimesheetTag>Light Blue</TranslatorTimesheetTag>, code: "#CEDDFF" },
  { name: <TranslatorTimesheetTag>Peach</TranslatorTimesheetTag>, code: "#FFE0C8" },
  { name: <TranslatorTimesheetTag>Baby Green</TranslatorTimesheetTag>, code: "#F4FFD4" },
  { name: <TranslatorTimesheetTag>Blush</TranslatorTimesheetTag>, code: "#FFE6D8" },
  { name: <TranslatorTimesheetTag>Lemon Chiffon</TranslatorTimesheetTag>, code: "#F6FFE5" },
  { name: <TranslatorTimesheetTag>Honeydew</TranslatorTimesheetTag>, code: "#D9FFDA" },
  { name: <TranslatorTimesheetTag>Pale Cyan</TranslatorTimesheetTag>, code: "#D1FFFD" },
  { name: <TranslatorTimesheetTag>Pale Aqua</TranslatorTimesheetTag>, code: "#EBFFF9" },
];

export { colorCodes, textColorCodes, shiftCodes, shiftCodesWithNames };
